import { useContext } from 'react';
import { ToastNotificationContext } from '../contexts/toastNotification/ToastNotification';

const useToastNotification = () => {
  const context = useContext(ToastNotificationContext);
  if (!context) {
    throw new Error(
      'useToastNotification debe usarse dentro de un ToastNotificationProvider'
    );
  }
  return context;
};

export default useToastNotification;
